import * as React from 'react';
import {NavBar, Icon, Toast} from 'antd-mobile';
import { Link} from 'react-router-dom';
import {WhiteSpace, WingBlank} from 'antd-mobile';

import dal from '../data/DAL';

let debug = require('debug')('APP:ConnectHelp')


/**
 * 连接帮助页面
 */
export default class ConnectHelp extends React.Component {



    render() {
        return (
            <div className="App">
                <NavBar
                    mode="light"
                    icon={<Link to={"/home"}><Icon color={'#666666'} size={'lg'} type="left"/></Link>}
                    onLeftClick={() => console.log('onLeftClick')}
                    rightContent={[]}>
                    连接方法
                </NavBar>
                <WhiteSpace size="lg"/>
                <WingBlank>
                    {/*<Button type="primary" size="small" style={{}}  onClick={this.downloadConfigFile}>下载配置文件</Button>*/}
                    {/*<WhiteSpace />*/}
                    {/*<img src={connectHelpImg} style={{width: "100%"}} alt=""/>*/}
                    <div style={{marginLeft: 40}}>
                        <WhiteSpace size="lg"/>
                        <div>
                            <span className='custom-label'>1</span>
                            <span style={{color: '#222222'}}>进入系统设置</span>
                        </div>
                        <WhiteSpace size="lg"/>
                        <div>
                            <img style={{width: 50, marginLeft: 40}} src={require('../images/set.png')}/>
                        </div>
                        <WhiteSpace size="lg"/>
                        <WhiteSpace size="lg"/>
                        <div>
                            <span className='custom-label'>2</span>
                            <span style={{color: '#222222'}}>选择VPN</span>
                        </div>
                        <WhiteSpace size="lg"/>
                        <div>
                            <img style={{width: 100, marginLeft: 25}} src={require('../images/vpn.png')}/>
                        </div>

                        <WhiteSpace size="lg"/>
                        <WhiteSpace size="lg"/>
                        <div>
                            <span className='custom-label'>3</span>
                            <span style={{color: '#222222'}}>选择任意域名，开启连接</span>
                        </div>
                        <WhiteSpace size="lg"/>
                        <div>
                            <img style={{width: 250, marginLeft: 40}} src={require('../images/xuanzhe.png')}/>
                        </div>
                        <WhiteSpace size={"lg"}/>
                        <WhiteSpace size={"lg"}/>
                    </div>
                </WingBlank>
            </div>
        );
    }
}

